import { render, staticRenderFns } from "./_form.vue?vue&type=template&id=e15b7f14&"
import script from "./_form.vue?vue&type=script&lang=ts&"
export * from "./_form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports